/** PageType => PODSTRONA */
export enum PageType {
  NotFoundPage = "not-found-page",
  BiuroRachunkowePage = "biuro-rachunkowe-page",
  CennikPage = "cennik-page",
  CookiesPage = "cookies-page",
  DotacjePage = "dotacje-page",
  FaqPage = "faq-page",
  FunkcjePage = "funkcje-page",
  LandingPage = "landing-page",
  KontaktPage = "kontakt-page",
  NaszZespolPage = "nasz-zespol-page",
  PorownaniePakietowPage = "porownanie-pakietow-page",
  RegulaminPage = "regulamin-page",
  ZakladanieSpolekZooPage = "zakladanie-spolek-zoo-page",
  KalkulatorWynagrodzenPage = "kalkulator-wynagrodzen-page",
  ProgramDoFakturPage = "program-do-faktur-page",
  LikwidacjaSpolekPage = "likwidacja-spolek-page",
  PolitykaRachunkowosciPage = "polityka-rachunkowosci-page"
}

/** PromoBlockType => TYP PROMO BLOCKA */
export enum PromoBlockType {
  PromoBlockGrayBox = "PromoBlockGrayBox",
  PromoBlockWhiteBox = "PromoBlockWhiteBox",
  PromoBlockIconBox = "PromoBlockIconBox",
  PromoBlockThemeColorBox = "PromoBlockThemeColorBox",
  PromoBlockFullWidthThemeColorBox = "PromoBlockFullWidthThemeColorBox"
}

/** AlertType => TYP ALERTA */
export enum AlertType {
  Info = "Info",
  Success = "Success",
  Warning = "Warning",
  Danger = "Danger",
}


// WEBPACK FOOTER //
// ./src/models/types.ts